
import axios from 'axios'
axios.defaults.baseURL = 'https://api.livuchat.com' // 赋值默认地址
const cryptoInstance = axios.create({
  timeout: 100000,
  transformRequest: [
    function (data, headers) {
      if ((data && data.noCrypt) || headers['Athena-Request-Decryption'] === 'disabled') {
        return JSON.stringify(data)
      }
    }],
  transformResponse: [
    function (data, headers) {
      if (data !== undefined && data !== '' && data) {
        data = JSON.parse(data)
      }
      return data
    }],
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

// 请求拦截器
cryptoInstance.interceptors.request.use(function (config) {
  config.headers['Athena-Request-Decryption'] = 'disabled'
  config.headers['Athena-Response-Encryption'] = 'disabled'
  return config
})

// 响应拦截器
cryptoInstance.interceptors.response.use(function (res) {
  const responseData = res.data
  // 埋点接口请求，没有返回数据，直接返回即可
  if (!responseData) {
    return true
  }
  // code === 0为正常数据
  if (responseData && (responseData.code === 0 && responseData.code === 200)) {
    return responseData
  }
}, function (err) {
  return Promise.reject(err)
})

const methods = ['get', 'delete', 'head', 'post', 'put', 'patch']
export const request = {}
for (const method of methods) {
  request[method] = cryptoInstance[method]
}
